import CompanionCard from './CompanionCard';
import { Companion, CompanionCategory } from '../api/model';

interface CompanionCarouselProps {
  category: CompanionCategory;
  onStartChat: (companion: Companion) => void;
  onCompanionSelect: (companion: Companion) => void;
  featuredCompanion: Companion | null;
  companions: Companion[];
}

function CompanionCarousel({
  category,
  onStartChat,
  onCompanionSelect,
  featuredCompanion,
  companions,
}: CompanionCarouselProps) {
  const filteredCompanions = companions.filter((companion) => companion.category === category);
  if (filteredCompanions.length === 0) return null;
  return (
    <section className="px-4 lg:px-8 CompanionCarousel">
      <h2 className="text-2xl lg:text-3xl font-title font-medium text-kind-purple mb-4 lg:mb-6">
        {category}
      </h2>
      <div
        className="flex overflow-x-auto space-x-4 lg:space-x-6 pb-6 scrollbar-hide"
        style={{ WebkitOverflowScrolling: 'touch' }}
      >
        {filteredCompanions
          .filter((companion) => companion.category === category)
          .map((companion) => (
            <CompanionCard
              key={companion.id}
              companion={companion}
              onStartChat={onStartChat}
              onCompanionSelect={onCompanionSelect}
              isFeatured={featuredCompanion?.id === companion.id}
            />
          ))}
      </div>
    </section>
  );
}

export default CompanionCarousel;
